import React from "react"
import PrimaryButton from "../../../../global/components/buttons/primary-button/PrimaryButton"
import { LocationModal } from "../../location-modal/components/container-modal/LocationModal"
import styles from "./styles.module.css"

export default function NewLocation() {
	const [open, setOpen] = React.useState(false)
	const handleOpen = () => {
		setOpen(true)
	}


	const handleClosed = () => {
		setOpen(false)
	}


	return (
		<div className={styles.makeAppContainer}>
			<div className={styles.inputsContainer}>
				<PrimaryButton
					buttonName="Create New Location"
					onClick={handleOpen}
				/>
			</div>
			{open && <LocationModal
				isOpen={open}
				handleClosed={handleClosed}
			/>}
		</div>
	)
}
